export default "__VITE_ASSET___uHhuPP0__"